export default __webpack_public_path__ + "static/media/Eb0.980e415e.mp3";